import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from 'gu-ui-kit/Button'
import Grid from 'gu-ui-kit/Grid/Container'
import Icon from 'gu-ui-kit/Icon'
import Typography from 'gu-ui-kit/Typography'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import LanguageSelector from 'components/Footer/subcomponents/LanguageSelector'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { APP_PRODUCT_PUBLIC_NAME, APP_PRODUCT } from 'constants/app-config'
import { IS_APP_PRODUCT_GETUNIQ } from 'utils/constants/product'
import styles from 'components/Footer/footer.module.scss'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

const SOCIAL_LINKS_BY_PRODUCT = {
  adsimple: [
    { href: 'https://t.me/AdSimple_me', icon: 'socials-telegram' },
    {
      href: 'https://www.facebook.com/people/AdSimple/61566322094569/',
      icon: 'socials-facebook',
    },
    {
      href: 'https://www.youtube.com/channel/UCkp8PHO7LYgMn5Ddth2f-DQ',
      icon: 'socials-youtube',
    },
  ],
  getuniq: [
    { href: 'https://t.me/getuniq', icon: 'socials-telegram' },
    { href: 'https://vk.ru/getuniqme', icon: 'socials-vk' },
    {
      href: 'https://youtube.com/@getuniq7721?si=EkeHqudwrg8e_IqY',
      icon: 'socials-youtube',
    },
  ],
}

const Footer = ({ wide = false, compact = false }) => {
  const pathGen = useGeneratePathI18n()
  const breakpoints = useBreakpoint()
  const { t } = useTranslation(['common'])
  const isStacked = compact || (wide && breakpoints.fb)
  const socialLinks = SOCIAL_LINKS_BY_PRODUCT[APP_PRODUCT] ?? []

  return (
    <Grid
      alignItems={'center'}
      className={styles['footer']}
      direction={breakpoints.fb ? 'row' : 'column'}
      gap={24}
      justifyContent={'space-between'}
      wrap={false}
    >
      <Grid
        alignItems={isStacked ? 'start' : 'center'}
        direction={isStacked ? 'column' : 'row'}
        fluid={false}
        gap={breakpoints.xl && !wide && !compact ? 24 : 16}
        justifyContent={wide ? 'start' : 'space-between'}
        wrap={!breakpoints.xl}
      >
        <Grid
          direction={'row'}
          fluid={false}
          gap={4}
          wrap={false}
        >
          <Typography
            noWrap
            color={'Label-Secondary'}
            variant={'Body-15'}
          >
            © {new Date().getFullYear()}
          </Typography>
          <Typography
            noWrap
            color={'Label-Secondary'}
            component={Link}
            to={pathGen(ROUTES.MAIN)}
            variant={'Body-15'}
          >
            {APP_PRODUCT_PUBLIC_NAME}
          </Typography>
        </Grid>

        {socialLinks.length > 0 && (
          <Grid
            fluid={false}
            gap={16}
            wrap={'nowrap'}
          >
            {socialLinks.map(({ href, icon }) => (
              <Button
                key={href}
                noLabel
                component={'a'}
                href={href}
                rel={'noopener noreferrer'}
                size={'s'}
                startIcon={<Icon name={icon} />}
                target={'_blank'}
                variant={'ghost'}
              />
            ))}
          </Grid>
        )}
      </Grid>

      <Grid
        as={'nav'}
        fluid={false}
        gap={16}
        justifyContent={'center'}
      >
        <Typography
          color={'Label-Secondary'}
          component={'a'}
          href={pathGen(ROUTES.OFERTA)}
          variant={'Body-15'}
        >
          {t('footer.user_agreement')}
        </Typography>
        <Typography
          color={'Label-Secondary'}
          component={'a'}
          href={pathGen(ROUTES.PRIVACY_POLICY)}
          variant={'Body-15'}
        >
          {t('footer.privacy_policy')}
        </Typography>
        <Typography
          color={'Label-Secondary'}
          component={'a'}
          href={pathGen(ROUTES.CONTACTS)}
          variant={'Body-15'}
        >
          {t('footer.contacts')}
        </Typography>
        <Typography
          color={'Label-Secondary'}
          component={'a'}
          href={pathGen(ROUTES.FAQ)}
          variant={'Body-15'}
        >
          {t('footer.help')}
        </Typography>

        {IS_APP_PRODUCT_GETUNIQ && (
          <Typography
            color={'Label-Secondary'}
            component={'a'}
            href={`${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_DOMAIN}${ROUTES.BLOG_URL}`}
            rel={'noopener noreferrer'}
            target={'_blank'}
            variant={'Body-15'}
          >
            {t('footer.blog')}
          </Typography>
        )}
      </Grid>

      <Grid
        direction={!breakpoints.fb && breakpoints.md ? 'column' : 'row'}
        fluid={false}
        gap={!breakpoints.md ? 24 : 8}
        justifyContent={'between'}
        wrap={false}
      >
        <LanguageSelector />
      </Grid>
    </Grid>
  )
}

export default Footer

Footer.propTypes = {
  wide: PropTypes.bool,
  compact: PropTypes.bool,
}
